import { useGetResolution886ReviewResults } from '@/hooks/v2/resolution-886';
import { getReviewId } from '../../../InitialVersion/_hooks/getReviewId';
import { I18n } from '@aws-amplify/core';

interface GeneralInformationData {
	company: string;
	industrialSite: string;
	sector: string;
	line: string;
	workPosition: string;
	activity: string;
	nameOfEvaluation: string;
	dateOfInitialVersion: string;
	version: string;
	numberOfWorkers: string;
	nameOfWorkers: string;
	writtenWorkProcedure: string;
	training: string;
	earlyManifestation: string;
	locationOfSymptom: string;
}

export function getValueOrDefault(value: string | number | undefined | null, defaultValue: string = '-'): string {
	return value ? String(value) : defaultValue;
}

export const useGetGeneralInformation = (report: any, selectedReviewId?: string) => {
	const actualReviewId = getReviewId(selectedReviewId, report?.reviews);

	const {
		data: reviewResults,
		isLoading,
		error
	} = useGetResolution886ReviewResults({
		report_id: report?.id,
		company_id: report?.company?.id,
		organization_id: report?.organization?.id,
		review_id: actualReviewId
	});

	const initialDate = report?.reviews?.[0]?.created_at || '-';

	const generalInformation: GeneralInformationData | null = reviewResults
		? {
				company: getValueOrDefault(reviewResults.company?.name),
				industrialSite: getValueOrDefault(reviewResults.organization?.name),
				sector: getValueOrDefault(reviewResults.sector?.name),
				line: getValueOrDefault(reviewResults.line?.name),
				workPosition: getValueOrDefault(reviewResults.workstation?.name),
				activity: getValueOrDefault(
					reviewResults.assessments
						?.map((a) => a.activity?.name)
						.filter(Boolean)
						.join(', ')
				),
				nameOfEvaluation: getValueOrDefault(reviewResults.name),
				dateOfInitialVersion: getValueOrDefault(initialDate),
				version: reviewResults.version === 0 ? I18n.get('Initial') : `${I18n.get('Version')} ${reviewResults.version}`,
				numberOfWorkers: getValueOrDefault(reviewResults.workers?.length?.toString()),
				nameOfWorkers: getValueOrDefault(reviewResults.workers?.map((worker) => worker.name).join(', ')),
				writtenWorkProcedure: reviewResults.written_work_procedure === 1 ? 'Yes' : 'No',
				training: reviewResults.training === 1 ? 'Yes' : 'No',
				earlyManifestation: reviewResults.early_manifestation === 1 ? 'Yes' : 'No',
				locationOfSymptom: getValueOrDefault(reviewResults.symptom_location)
		  }
		: null;

	return {
		generalInformation,
		isLoading,
		error
	};
};
